import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../../../../firebase'
import StateContext from '../../../../../StateContext'
import FixtureTemplate from './FixtureTemplate'
import SingleTeamFixtureByDate from './SingleTeamFixtureByDate'

function FavoriteTeamsLive({ date, type, allFixtures }) {
    const appState = useContext(StateContext)

    const [teams, setTeams] = useState([])
    const [teamIds, setTeamIds] = useState([])

    const [favoriteFixtures, setFavoriteFixtures] = useState([])

    useEffect(() => {
        if (appState.userId) {
            try {
                const favTeams = firestore
                    .collection('users')
                    .doc(appState.userId)
                    .collection('favoriteTeamsAPI')
                favTeams.onSnapshot(({ docs }) => {
                    const teams = docs.map((doc) => {
                        return { id: doc.id, ...doc.data() }
                    })
                    setTeams(teams)

                    const teamIds = teams.map((team) => {
                        return team.team_id
                    })
                    setTeamIds(teamIds)
                })
            } catch (error) {
                console.log(error)
            }
        }
    }, [appState.userId])

    useEffect(() => {
        const favoriteFixtures = allFixtures.filter((fixture) => {
            return (
                teamIds.includes(fixture.homeTeam.team_id) ||
                teamIds.includes(fixture.awayTeam.team_id)
            )
        })
        setFavoriteFixtures(favoriteFixtures)
    }, [allFixtures, teamIds])

    return (
        <div>
            <div className="card card-header bg-lightgrey">
                <small>Favorittlag</small>
            </div>
            {favoriteFixtures?.map((fixture, index) => {
                return (
                    <FixtureTemplate
                        key={index}
                        index={index}
                        fixture={fixture}
                        type={type}
                    />
                )
            })}
        </div>
    )
}
export default FavoriteTeamsLive
